namespace Areas.Ucla.Detail {
    "use strict";

    export function onContentReady() {
        Areas.ckeditorInit('superseded-bybookmark', '100px');
        Areas.ckeditorInit('superseded-bylink', '100px');
        Areas.ckeditorInit('comments', '100px');
        Areas.ckeditorInit('bodytext-attachment', '100px');
        Areas.ckeditorInit('all-references', '100px');
        Areas.ckeditorInit('body-text', '400px');
    }

    export function save() {
        const form = $("#DaUclaForm").dxForm("instance");
        const dauclaId = form.option("DaUclaId");
        const newData: any = form.option("formData");

        getCkEditorData(newData);

        const result: any = form.validate();

        if (result.isValid) {
            sendRequest(`/UCLA/Detail/Put/${dauclaId}`, JSON.stringify(newData), "PUT");
        }
    }

    function getCkEditorData(data: any) {
        data.SupersededByBookmark = Areas.ckeditorGet('superseded-bybookmark');
        data.SupersededByLink = Areas.ckeditorGet('superseded-bylink');
        data.Comments = Areas.ckeditorGet('comments');
        data.BodyTextAttachment = Areas.ckeditorGet('bodytext-attachment');
        data.AllReferences = Areas.ckeditorGet('all-references');
        data.BodyText = Areas.ckeditorGet('body-text');
    }

    export function goBack() {
        location.href = '/UCLA/List/Index';
    }

    export function sourceDaTemplate(itemData, itemIndex, itemElement) {
        itemElement.css("text-align", "left");
        var leftBlock = $("<div style='display:inline-block; margin: 5px;'>");
        leftBlock.append(itemData.publishedNumber + " - " + itemData.daUclaFileName);
        itemElement.append(leftBlock);
        var rightBlock = $("<div style='display:inline-block; margin: 5px;'>");
        rightBlock.append(itemData.documentTitle);
        itemElement.append(rightBlock);
    }

    export function sourceDaFieldTemplate(selectedItem, fieldElement) {
        var element = $("<div>");
        element.append(
            selectedItem ? selectedItem.publishedNumber + ' (' + selectedItem.daUclaFileName + ') ' + selectedItem.documentTitle : 'Select ...'
        );
        fieldElement.append(element);
    }

}